import Repository from './../Repository';

const resource = 'admin/homework';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
}